<template>
  <div class="content">
    <div class="rule">
      <span class="ruleMsg" @click="handleChange">
        <i></i>
        <span>活动规则</span>
      </span>
    </div>
    <div class="sudoku" v-if="show9">
      <ul>
        <li
          v-for="(item,idx) in prizeList"
          :key="item.position"
          :class="['p'+item.position,{'on':idx==current}]"
        >
          <img :src="item.picture" :alt="item.prize">
        </li>
        <div class="btnStart" @click="start">
          <span class="big">立即抽奖</span>
          <span class="small">(消耗10积分)</span>
        </div>
      </ul>
    </div>
    <transition name="fade">
      <GetQB v-if="open.GetQB" :drawId="Id" @cancle="()=>{this.open.GetQB=!this.open.GetQB}"/>
      <GetSw v-if="open.GetSw" :drawId="Id" @cancle="()=>{this.open.GetSw=!this.open.GetSw}"/>
      <Bingo v-if="open.Bingo" :top="top" :title="title" @cancle="handleBingo"/>
      <Rule v-if="open.Rule" @cancle="handleChange" :idx="0"/>
    </transition>
  </div>
</template>

<script>
import Rule from "./Rule";
import Bingo from "../common/Bingo";
import GetSw from "./GetSw";
import GetQB from "./GetQB";
import {prize_list,draw} from '../../utils/config'
export default {
  props: {
    url: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Rule,
    Bingo,
    GetSw,
    GetQB
  },
  data: () => ({
    open: {
      GetSw: false,
      Bingo: false,
      Rule: false,
      GetQB: false
    },
    top:"",
    title: "",
    prizeList: [],
    speed: 200,
    diff: 15,
    award: {},
    time: 0,
    current: -1,
    ok: true,
    Id: ""
  }),
  computed: {
    show9() {
      return this.prizeList.length <= 8;
    }
  },
  mounted() {
    this.$axios({
      withCredentials: true,
      crossDomain: true,
      url:prize_list,
      method: "get"
    }).then(res => {
      this.prizeList = res.data.data;
    });
  },
  methods: {
    handleBingo() {
      this.current=-1;
      if (this.award.type == "SW") {
        this.open.GetSw = true;
      }
      if (this.award.type == "QB") {
        this.open.GetQB = true;
      }
      if(this.award.type == "LINK"){
        this.prizeList.map(item=>{
          if(item.type == "LINK"){
            window.location.href=item.description
          }
        })
      }
      this.open.Bingo = !this.open.Bingo;
    },
    handleChange() {
      this.open.Rule = !this.open.Rule;
    },
    start() {
      // 开始抽奖
      if (this.url.from == "ldq") {
        if (this.ok) {
          this.drawAward();
          this.time = Date.now();
          this.speed = 120;
          this.diff = 0;
          this.timeout;
        }
      } else {
        this.title = "请下载安装雷电圈APP";
        this.open.Bingo = !this.open.Bingo;
      }
    },
    drawAward() {
      this.$axios({
        withCredentials: true,
        crossDomain: true,
        url:draw,
        method: "get"
      }).then(res => {
        let state = res.data;
        if (state.code == 0) {
          this.award = state.data;
          this.$emit('deduct',this.award);
          this.move();
        } else {
          this.$emit('login',state.msg);
        }
      });
    },
    move() {
      this.ok = false;
      this.timeout = setTimeout(() => {
        this.current++;
        if (this.current > 7) {
          this.current = 0;
        }
        if (
          this.award.position ||
          (this.award.position == 0 && (Date.now() - this.time) / 400 > 2)
        ) {
          this.speed += this.diff;
          if (
            (Date.now() - this.time) / 400 > 4 &&
            this.award.position == this.prizeList[this.current].position
          ) {
            clearTimeout(this.timeout);
            setTimeout(() => {
              this.ok = true;
              this.title = this.award.prize;
              this.top=this.award.type!='NONE' ? '恭喜获得' : '';
              this.Id = this.award.id;
              this.open.Bingo = true;
            }, 0);
            return;
          }
        } else {
          this.speed -= this.diff;
        }

        this.move();
      }, this.speed);
    }
  }
};
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.content {
  height: 566px;
  .rule {
    padding: 0 88px;
    display: flex;
    justify-content: flex-end;
    i {
      display: block;
      width: 25px;
      height: 25px;
      margin-right: 5px;
      background:url('../assets/small.jpg') no-repeat;
      background-size: 100% 100%;
    }
    .ruleMsg {
      display: block;
      font-size: 22px;
      display: flex;
      span {
        display: block;
        height: 24px;
        border-bottom: 1px solid #000;
      }
    }
  }
  .sudoku {
    height: 470px;
    width: 590px;
    margin: 20px auto 0;
    ul {
      width: 100%;
      height: 100%;
      position: relative;
      li {
        position: absolute;
        width: 180px;
        height: 145px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .p0 {
        top: 0;
        left: 0;
      }
      .p1 {
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .p2 {
        top: 0;
        right: 0;
      }
      .p3 {
        top: 50%;
        transform: translateY(-50%);
        right: 0;
      }
      .p4 {
        bottom: 0;
        right: 0;
      }
      .p5 {
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
      }
      .p6 {
        left: 0;
        bottom: 0;
      }
      .p7 {
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .on {
        opacity: 0.7;
      }
    }
  }
  .btnStart {
    cursor: pointer;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 180px;
    height: 145px;
    background: url("../assets/sudoku.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .big {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 18px;
    }
    .small {
      font-size: 20px;
      color: #d2baf0;
    }
  }
}
</style>
